module.exports = __webpack_public_path__ + "img/miryoku_c3.be530c58.png";